import { BaseEntity } from "@portal/types/entities/base-entity";
import { DocumentConfigs } from "@portal/types/entities/documents";

const documentConfig: DocumentConfigs = {
  INVOICE: {
    label: "Invoice",
    style: {
      borderColor: "var(--transparent)",
      backgroundColor: "var(--geekblue-1)",
      textColor: "var(--geekblue-6)",
    },
  },
  CUSTOMER: {
    label: "Customer",
    style: {
      borderColor: "var(--cyan-1)",
      backgroundColor: "var(--cyan-1)",
      textColor: "var(--cyan-6)",
    },
  },
};

export function getDocumentConfig(status: BaseEntity) {
  return documentConfig[status];
}
